import React, {Component} from "react";
import InputMask from "react-input-mask"
import classNames from "classnames";

export default class PhoneNumberMask extends Component{
    constructor() {
        super(...arguments);

        this.state = {value: this.props.value || ''};
    }

    handleChange(value) {
        let number = value.replace(/(\+380)|(\s|\(|\)|_)/g, '');
        this.props.onChange(this.props.attribute, number);
        this.setState({value: value})
    }

    render() {
        return (
            <div>
                <InputMask
                    mask="+380 (99) 999 9999"
                    value={this.state.value}
                    onChange={(e) => this.handleChange(e.target.value)}
                    disabled={this.props.readonly}
                >
                    {(inputProps) => <input
                        {...inputProps}
                        type="tel"
                        className={classNames('form-control', {'is-invalid': this.props.invalid})}
                        placeholder="Введіть номер телефону"
                        required
                        pattern={"^\\+380\\s\\([0-9]{2}\\)\\s[0-9]{3}\\s[0-9]{4}$"}
                    />}
                </InputMask>
            </div>
        );
    }
}
